import {
    Button,
    Flex,
    Heading,
    Link,
    Box
} from '@chakra-ui/react';
import React, { useEffect, useRef, useState } from 'react';
import Swal from 'sweetalert2';
import PerfilAcessoService from "../../../main/services/PerfilAcessoService";
import { Link as ReactLink, useHistory } from "react-router-dom";
import VisualizarInfo from './VisualizarInfo';
import { useAuthProvider } from "../../../Context/AuthProvider";
import SemRegistros from '../../components/SemRegistros';
import { criancaFunc } from '../../../helpers/Funcionalidades';

const VisualizarPerfilAcesso = (props) => {

    document.title = 'MCA - Perfis de Acesso - Visualizar'
    let history = useHistory()

    const { roleKeycloack } = useAuthProvider();
    const _IsMounted = useRef(false);
    const [perfilAcesso, setPerfilAcesso] = useState([]);
    const [isUpdating] = useState(props.match.params.editar ? true : false);

    useEffect(() => {
        _IsMounted.current = true;
        fetchData();
        return () => {
            _IsMounted.current = false;
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    function fetchData() {
        PerfilAcessoService.getPerfilAcesso(props.match.params.id)
            .then(res => {
                setPerfilAcesso(res.data)
            }).catch(() => {
                Swal.fire({
                    title: 'Atenção!',
                    text: "Registro não encontrado",
                    icon: 'warning',
                    confirmButtonText: 'Fechar',
                    confirmButtonColor: '#169499'
                }).then(() => {
                    history.push("/perfil-acesso/lista");
                })
            })
    }

    function checkStatus(acao) {
        let updated;
        PerfilAcessoService.getPerfilAcesso(props.match.params.id)
            .then(res => {
                updated = res.data
                const acaoUp = updated.dataFim ? "reativar" : "inativar";
                if (acaoUp !== acao) {
                    Swal.fire({
                        title: 'Atenção',
                        text: updated.dataFim ?
                            "Este registro já está inativo. Deseja reativá-lo?" :
                            "Este registro está ativo. Deseja inativá-lo?",
                        icon: 'warning',
                        showCancelButton: true,
                        confirmButtonColor: '#169499',
                        cancelButtonColor: '#169499',
                        confirmButtonText: updated.dataFim ?
                            "Sim, quero reativar!" :
                            "Sim, quero inativar!",
                        cancelButtonText: 'Cancelar'
                    }).then((result) => {
                        if (result.isConfirmed) {
                            history.push("/perfil-acesso/alterar-vigencia/" + updated.id);
                        }
                    })
                } else {
                    history.push("/perfil-acesso/alterar-vigencia/" + updated.id);
                }
            })
    }

    return roleKeycloack && roleKeycloack.includes(criancaFunc.visualizarTudo) ? (
        <Flex
            pt={"20px"}
            px={["5px", "30px"]}
            h="100%"
            flexDir="column"
            w="100%"
            maxW="2000px"
            overflow="auto"
            pb={["10px", "20px"]}
        >
            <Flex flexDir="row" justifyContent="space-between">
                <Heading fontSize={'large'}>
                    Visualizar Perfil de Acesso
                </Heading>
                <Link as={ReactLink} to="/perfil-acesso/lista" _hover={{ textDecoration: "none" }}>
                    <Button colorScheme={"teal"} px={16}>
                        Voltar
                    </Button>
                </Link>
            </Flex>
            <Flex flexDir="column">
                <Flex
                    mt="25px"
                    flexDir="column"
                    borderRadius="20px"
                    w="100%"
                    overflow="hidden"
                >
                    <VisualizarInfo
                        title="Nome do Perfil"
                        info={perfilAcesso.descricao || "Não possui"}
                        bgColor="#F9FAFB"
                    />
                    <VisualizarInfo
                        title="Tipo de Órgão"
                        info={perfilAcesso.tipoOrgao || "Não possui"}
                        bgColor="#FFFFFF"
                    />
                    <VisualizarInfo
                        title="Data Início"
                        info={perfilAcesso.dataInicio || "Não possui"}
                        bgColor="#F9FAFB"
                    />
                    {perfilAcesso.dataFim && (
                        <VisualizarInfo
                            title="Data Fim"
                            info={perfilAcesso.dataFim}
                            bgColor="#FFFFFF"
                        />
                    )}
                </Flex>

                <Flex mt={2} justifyContent="space-between">
                    <Flex></Flex>
                    <Flex flexDir={"row"}>
                        {perfilAcesso.dataFim ? (
                            <></>
                        ) : (
                            <Link
                                as={ReactLink}
                                to={"/perfil-acesso/editar/" + perfilAcesso.id}
                                _hover={{ textDecoration: 'none' }}>
                                <Button mr={2} mt={4} colorScheme={"teal"} px={14} type="button">
                                    {isUpdating ? "Cancelar" : "Editar"}
                                </Button>
                            </Link>
                        )}

                        <Button
                            mt={4}
                            mr={2}
                            colorScheme={"teal"}
                            px={14}
                            data-acao={perfilAcesso.dataFim ? "reativar" : "inativar"}
                            onClick={(e) => { checkStatus(e.target.dataset.acao) }}
                            type="button">
                            {perfilAcesso.dataFim ? "Reativar" : "Inativar"}
                        </Button>
                    </Flex>
                </Flex>
            </Flex>
        </Flex>
    ) : (
        <Box mt={2}>
            <SemRegistros buttonVisible={true} half />
        </Box>
    );
}

export default VisualizarPerfilAcesso;
